// import { CameraDirector } from "stage/cameraDirector/cameraDirector";
import * as THREE from "three";
import GUI from "lil-gui";
import { GLTF, GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { Font, FontLoader } from "three/examples/jsm/loaders/FontLoader";


const HELPERS = true;

export class Stage {
  public scene: THREE.Scene;
  public camera: THREE.PerspectiveCamera;
  public renderer: THREE.WebGLRenderer;
  // private cameraDirector: CameraDirector;
  public gui: GUI;
  //
  public assets: {
    models: GLTF[];
    textures: THREE.Texture[];
    hdri: THREE.DataTexture[];
    fonts: Font[];
  } = {
    models: [],
    textures: [],
    hdri: [],
    fonts: [],
  };

  constructor(public canvas: HTMLCanvasElement) {
    // scene
    this.scene = new THREE.Scene();
    // this.scene.background = new THREE.Color(0x02131b);

    // gui
    this.gui = new GUI();
    if (!this.isDebug()) {
      this.gui.hide();
    }

    // camera
    const ratio = canvas.clientWidth / canvas.clientHeight;
    this.camera = new THREE.PerspectiveCamera(50, ratio, 1, 500);
    this.scene.add(this.camera);
    // camera gui
    const giuCamera = this.gui.addFolder("Camera");
    giuCamera.add(this.camera.position, "x", -10, 10, 0.05);
    giuCamera.add(this.camera.position, "y", -10, 10, 0.05);
    giuCamera.add(this.camera.position, "z", -10, 10, 0.05);
    // add camera director
    // this.cameraDirector = new CameraDirector(this.camera);

    // renderer
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: true,
    });

    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    const pixelRatioFactor = 1;
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio*pixelRatioFactor, 4));
    this.renderer.setSize(canvas.clientWidth, canvas.clientHeight);
    // this.renderer.toneMapping = THREE.ACESFilmicToneMapping;
    
    this.renderer.setAnimationLoop(this.render);

    // add resize EL
    window.addEventListener("resize", this.onResize);
  }

  private onResize = () => {
    this.handleResize();
  };
  
  protected handleResize() {
    this.camera.aspect = this.canvas.clientWidth / this.canvas.clientHeight;
    this.camera.updateProjectionMatrix();

    this.renderer.setSize(this.canvas.clientWidth, this.canvas.clientHeight);
    this.renderer.render(this.scene, this.camera);
  }

  public render = (elapsedTime: any, deltaTime: any) => {
    this.update(elapsedTime, deltaTime);
    this.renderer.render(this.scene, this.camera);
  };

  public update = (elapsedTime: number, deltaTime: number) => {};

  public load(
    data: { models: string[]; textures: string[]; hdri: string[]; fonts: string[]; },
    onComplete: () => void
  ) {

    const loadingManager = new THREE.LoadingManager(
      () => {
        onComplete();
      },
      (url: string, loaded: number, total: number) => {
        // progress
        // console.log("progress", loaded, total);
      }
    );

    this.assets = {
      models: [],
      textures: [],
      hdri: [],
      fonts: [],
    };

    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderConfig({ type: "js" });
    dracoLoader.setDecoderPath("https://www.gstatic.com/draco/v1/decoders/");

    // load models
    const gltfLoader = new GLTFLoader(loadingManager);
    gltfLoader.setDRACOLoader(dracoLoader);
    data.models.forEach((path, i) => {
      gltfLoader.load(path, (gltf) => {
        this.assets.models[i] = gltf;
      });
    });

    // load textures
    const textureLoader = new THREE.TextureLoader(loadingManager);
    data.textures.forEach((path, i) => {
      textureLoader.load(path, (texture) => {
        texture.encoding = THREE.sRGBEncoding;
        texture.needsUpdate = true;
        this.assets.textures[i] = texture;
      });
    });

    // load HDI
    const hdriLoader = new RGBELoader(loadingManager);
    data.hdri.forEach((path, i) => {
      hdriLoader.load(path, (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping;
        texture.needsUpdate = true;
        this.assets.hdri[i] = texture;
      });
    });

    // load Fonts
    const fontsLoader = new FontLoader(loadingManager);
    data.fonts.forEach((path, i) => {
      fontsLoader.load(path, (font) => {
        this.assets.fonts[i] = font;
      });
    });

    // });
  }
  isDebug() {
    return window.location.hash.includes("debug");
  }
  // DESTROY
  destroy() {
    // console.log('destroy')
    window.removeEventListener("resize", this.onResize);
    // this.cameraDirector.destroy();

    this.gui.destroy();
  }
}
